module.exports = __webpack_public_path__ + "img/amxpjLogo.91e7b909.png";